module.exports = __webpack_public_path__ + "static/media/nasa_logo.b44f0cfe.png";